import {
    Box,
    Button,
    Center,
    Container,
    createListCollection,
    Flex,
    HStack,
    Image as ImageChakra,
    Portal,
    Select,
    Spinner,
    Stack,
    Text,
    useDisclosure,
} from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import SVG from "react-inlinesvg";

import ScrollDown from "@/components/seleccion2D/ScrollDown";
import { useGetDevelopmentSelection2dQuery } from "@/hooks/microservicesApi";

const Seleccion2D = ({ onToggleSlide, onCloseSlide, isSlideOpen, setIsRouteViewer }) => {
    const router = useRouter();
    const [_windowWidth, setWindowWidth] = useState(
        typeof window === "undefined" ? 0 : window.innerWidth
    );
    const [_topSelectPosition, setTopSelectPosition] = useState("0px");
    const [propertySelected, setPropertySelected] = useState(null);
    const code = router.query.code;
    const url_ = router.query.hook;
    const { data, isLoading } = useGetDevelopmentSelection2dQuery(code);
    const [viewSelected, setViewSelected] = useState([]);
    const [_views, setViews] = useState([]);
    const [modelSelected, setModelSelected] = useState(null);
    const [renders, setRenders] = useState({});
    const [viewName, _setViewName] = useState(null);
    const [isOneTower, setIsOneTower] = useState(false);
    const [uniqueView, setUniqueView] = useState(null);
    const [multiProperty, setMultiProperty] = useState(null);

    const [isOneRender, setIsOneRender] = useState(false);
    const { open: isSlideOpenVision, onToggle: onToggleSlideVision } = useDisclosure();
    const [limitImage, setLimitImage] = useState(true);
    const [canScroll, setCanScroll] = useState(true);
    const [showDescription, setShowDescription] = useState(false);

    const modelOptions = Object.keys(multiProperty || {}).map((key) => ({
        value: key,
        label: multiProperty[key]?.model_name ?? "",
    }));

    const viewOptions = Object.keys(renders).map((key) => {
        if (renders[key][0].map_image_url !== null) {
            const item = renders[key];
            let string_name = "";
            if (!isOneTower) {
                string_name = item[0]?.outter_dimension_props[0]?.item_name.replace("condo_", "");
            }
            let string_ids = "";
            item.map((item_2) => {
                string_name = string_name + (string_name !== "" ? " / " : "") + item_2.item_name;
                string_ids = string_ids + (string_ids !== "" ? "*" : "") + item_2.tower_id;
            });
            return {
                value: string_name + "|" + string_ids,
                label: string_name,
            };
        }
    });
    const modelCollection = createListCollection({
        items: modelOptions,
    });

    const viewCollection = createListCollection({
        items: viewOptions,
    });

    // ==== ADJUST THE TOP POSITION OF COMPONENTE SELECT ON MOBILE SCREEN ====
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 440 && window.innerWidth > 420) {
                setTopSelectPosition("15px");
            } else if (window.innerWidth <= 420 && window.innerWidth > 399) {
                setTopSelectPosition("30px");
            } else if (window.innerWidth <= 399 && window.innerWidth > 368) {
                setTopSelectPosition("55px");
            } else if (window.innerWidth <= 368) {
                setTopSelectPosition("75px");
            } else {
                setTopSelectPosition("0px");
            }
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        // Limpieza del efecto
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        let count = 1;
        if (data) {
            for (let i = 0; i < data.length; i++) {
                if (i !== data.length - 1) {
                    if (data[i]?.map_image_url === data[i + 1]?.map_image_url) {
                        count++;
                    }
                }
            }
            if (count === data.length) {
                let properties = [];
                data.map((d) => {
                    properties.push(...d.property_props);
                });
                const uniqueVw = { ...data[0] };
                uniqueVw["property_props"] = properties;
                setUniqueView(uniqueVw);
                setIsOneRender(true);
                setIsOneTower(true);
            } else {
                let counter = 0;
                let mapImageMappedCounter = {};
                const result = Object.values(data).reduce((acc, curr) => {
                    const mapImageMapped = curr.map_image_url;

                    if (mapImageMappedCounter[mapImageMapped] === undefined) {
                        mapImageMappedCounter[mapImageMapped] = counter++;
                    }

                    const key = mapImageMappedCounter[mapImageMapped];
                    if (acc[key] === undefined) {
                        acc[key] = [];
                    }
                    acc[key].push(curr);
                    return acc;
                }, {});
                setRenders(result);
            }
        }
    }, [data]);

    useEffect(() => {
        if (renders) {
            let cont = 1;
            const keys = Object.keys(renders);
            keys.map((key, index) => {
                const currentElement = renders[key];
                const nextElement = index < keys.length - 1 ? renders[keys[index + 1]] : null;
                if (nextElement !== null) {
                    if (
                        currentElement[0]?.outter_dimension_props[0]?.item_name ===
                        nextElement[0]?.outter_dimension_props[0]?.item_name
                    ) {
                        cont++;
                    }
                }
            });

            if (cont === Object.keys(renders).length) {
                setIsOneTower(true);
            }
        }
    }, [renders]);

    useEffect(() => {
        const views_urls = [];
        const views_ = [];
        data?.map((element) => {
            views_urls.push(element.map_image_url);
            views_.push(element);
        });
        let views__ = [...new Set(views_urls)];
        if (views__.length === views_.length) {
            setViews(views__);
        }
    }, [data]);

    // ==== SET THE FIRST VIEW BY DEFAULT ====
    useEffect(() => {
        if (data && viewOptions.length > 0 && !isLoading && viewSelected.length === 0) {
            selectedView(viewOptions[0]?.value);
        } else if (data && isOneRender && !isLoading && viewSelected.length === 0) {
            setViewSelected(uniqueView);
        }
    }, [data, viewOptions, isLoading]);

    useEffect(() => {
        if (
            url_ &&
            modelSelected &&
            url_.includes("/inventory/development") &&
            !isSlideOpenVision
        ) {
            onToggleSlideVision();
        }
    }, [modelSelected]);

    const handleChangeUnity = () => {
        window.parent.postMessage({ type: "CHANGE_PROPERTY", text: modelSelected }, "*");
    };

    // ===== VALIDATE AFTER LOAD COMPONENT - STATUS OF PROPERTIES TO SET COLOR GREEN, RED OR YELLOW =====
    const loadSvg = () => {
        const svg = document.getElementById("svg");
        if (svg) {
            // Get current tower's properties
            // Since there could be multiple towers
            // with the same name (for example, torre "Norte" for 2 different views),
            // we need to find by tower_id
            if (!viewSelected?.property_props) return;

            // Create lookup map for O(1) access
            const propertyMap = new Map();
            viewSelected.property_props.forEach((prop) => {
                propertyMap.set(prop.property_id, prop);
            });

            // Process only the current tower's elements
            const elements = [
                ...svg.getElementsByTagName("rect"),
                ...svg.getElementsByTagName("path"),
            ];

            elements.forEach((element) => {
                if (!element.id) return;

                const property = propertyMap.get(element.id);
                if (property) {
                    // Color based on status
                    if (property.status === "ACTIVE") {
                        element.setAttribute("fill", "#00E503");
                        element.setAttribute("fill-opacity", 0.3);
                        element.style.cursor = "pointer";
                    } else if (property.status === "APART") {
                        element.setAttribute("fill", "#FFF300");
                        element.setAttribute("fill-opacity", 0.4);
                        element.style.cursor = "not-allowed";
                    } else {
                        element.setAttribute("fill", "#D80000");
                        element.setAttribute("fill-opacity", 0.3);
                        element.style.cursor = "not-allowed";
                    }
                } else {
                    // All elements that don't match any property (this includes the background base image)

                    // If for whatever reason an element that doesn't match any property
                    // has an id that contains a "_2"
                    // AND this id has a UUID format (see regex below)
                    // then color it red
                    // (TODO: verify who required this weird validation and why if it is still necessary)
                    const uuidRegex =
                        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
                    const parts = element.id.split("_2");
                    if (
                        (element.id.includes("_2") && uuidRegex.test(parts[0])) ||
                        uuidRegex.test(parts[0])
                    ) {
                        element.setAttribute("fill", "#D80000");
                        element.setAttribute("fill-opacity", 0.3);
                        element.style.cursor = "not-allowed";
                    }
                }
            });

            // ==== SET IMAGE HEIGHT LIMITS ====
            const rects = svg.getElementsByTagName("rect");
            if (rects.length > 0) {
                if (rects[0]?.height?.baseVal?.value > rects[0].width.baseVal.value * 1.7) {
                    setLimitImage(false);
                } else {
                    setLimitImage(true);
                }
            }
        }
    };

    const handleClick = (e) => {
        const id = e.target.id;
        const depa = document.getElementById(id);
        const depaColor = depa.getAttribute("fill");
        let flag = true;

        if (id.length >= 15) {
            if (depaColor !== "#D80000" && depaColor !== "#FFF300" && !depaColor.includes("url")) {
                // ==== CHANGE COLOR OF APARTMENT SELECTED ====
                if (
                    id.includes("sur") === false &&
                    id.includes("Sur") === false &&
                    id.includes("oriente") === false &&
                    id.includes("Oriente") === false &&
                    id.includes("norte") === false &&
                    id.includes("Norte") === false &&
                    id.includes("poniente") === false &&
                    id.includes("Poniente") === false
                ) {
                    if (!propertySelected) {
                        setPropertySelected(depa);
                        depa.setAttribute("fill", "#FFFFFF");
                        depa.setAttribute("fill-opacity", 0.6);
                    } else if (propertySelected && propertySelected !== id) {
                        const prevDepa = propertySelected;
                        prevDepa.setAttribute("fill", "#00E503");
                        prevDepa.setAttribute("fill-opacity", 0.3);
                        depa.setAttribute("fill", "#FFFFFF");
                        depa.setAttribute("fill-opacity", 0.6);
                        setPropertySelected(depa);
                    }
                }
                // ==== SHOW PHOTO AND DATA OF APARTMENT ====

                if (viewSelected?.property_props != null) {
                    viewSelected?.property_props.forEach((element) => {
                        if (element.property_id === id) {
                            if (element?.extra_props?.multi_property?.multi_type === "SON") {
                                addMultiProperty(element);
                            } else {
                                setMultiProperty(null);
                            }
                            flag = false;
                            setModelSelected(element);
                            parent.postMessage(element);
                        }
                    });
                }

                if (flag) {
                    data.forEach((d) => {
                        if (d.property_props != null) {
                            d.property_props.forEach((property) => {
                                if (property.property_id === id) {
                                    if (
                                        property?.extra_props?.multi_property?.multi_type === "SON"
                                    ) {
                                        addMultiProperty(property);
                                    } else {
                                        setMultiProperty(null);
                                    }
                                    setModelSelected(property);
                                    parent.postMessage(property);
                                }
                            });
                        }
                    });
                }
            }
        }
    };

    const selectedView = (e) => {
        //Dividir el string name de los tower_id's
        const value = e.split("|", 2);
        const tower_ids = value[1].split("*");

        _setViewName(e);
        const properties = [];
        let view = {};

        Object.keys(renders).map((key) => {
            const item = renders[key];
            item.map((rend) => {
                let string_name = "";
                if (!isOneTower) {
                    string_name = item[0]?.outter_dimension_props[0]?.item_name.replace(
                        "condo_",
                        ""
                    );
                }
                if (
                    !rend?.tower_id &&
                    value[0]?.includes(string_name) &&
                    value[0]?.includes(rend?.item_name)
                ) {
                    view = { ...rend };
                    setModelSelected(null);
                } else if (
                    tower_ids.includes(rend?.tower_id) &&
                    value[0]?.includes(string_name) &&
                    value[0]?.includes(rend?.item_name)
                ) {
                    view = { ...rend };
                    properties.push(...rend.property_props);
                }
            });
        });
        view["property_props"] = properties;
        setViewSelected(view);
        setModelSelected(null);
    };

    const addMultiProperty = (property) => {
        const viewProperties = viewSelected.property_props.filter((prop) =>
            property.extra_props.multi_property.properties.includes(prop.property_id)
        );
        viewProperties.push(property);
        setMultiProperty(viewProperties);
    };

    const handleHook = () => {
        if (url_ && url_.includes("aladra")) {
            const url_data = `https://www.grupoguia.mx/desarrollo/aladraresidencial/seleccion/planPayment?code=${modelSelected.property_id}&development_id=${modelSelected.development_id}`;
            window.open(url_data, "_blank");
        } else if (url_ && url_.includes("deimare")) {
            const url_data = `https://www.grupoguia.mx/desarrollo/deimaremarina&golfliving/seleccion/planPayment?code=${modelSelected.property_id}&development_id=${modelSelected.development_id}`;
            window.open(url_data, "_blank");
        } else if (url_ && url_.includes("vistabosque")) {
            const url_data = `https://www.grupoguia.mx/desarrollo/vistabosque/seleccion/planPayment?code=${modelSelected.property_id}&development_id=${modelSelected.development_id}`;
            window.open(url_data, "_blank");
        } else if (url_) {
            const url_data = `${url_}?developmentId=${modelSelected.development_id}&propertyId=${modelSelected.property_id}`;
            window.open(url_data, "_blank");
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            const scrollable = document.documentElement.scrollHeight > window.innerHeight;
            setCanScroll(scrollable && window.scrollY === 0);
        };

        // Check once on mount
        handleScroll();

        // Add scroll event listener
        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleScroll); // In case of resizing
        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
        };
    }, []);

    useEffect(() => {
        if (isSlideOpenVision) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [isSlideOpenVision]);

    return (
        <>
            {isLoading ? (
                <Box h="70vh">
                    <Center h="90vh">
                        <Spinner size="xl" color="#FFCD00" />
                    </Center>
                </Box>
            ) : (
                <Stack>
                    <Box
                        display={{ base: "block", md: "flex" }}
                        justifyContent={{ lg: "space-evenly" }}
                        pb={{ lg: "100px" }}
                        px={{ md: 6, lg: 0 }}
                    >
                        {canScroll && (
                            <Box
                                position="fixed"
                                bottom={window.innerWidth <= 480 ? "30px" : "92px"} // Ajusta el espacio desde la parte inferior
                                left="50%"
                                transform="translateX(-50%)"
                                zIndex="100"
                            >
                                <ScrollDown color="black" bgColor="white" />
                            </Box>
                        )}
                        {modelSelected ? (
                            <>
                                {window.innerWidth <= 480 && (
                                    <Stack
                                        flexDirection={
                                            url_ &&
                                            (url_.includes("aladra") ||
                                                url_.includes("deimare") ||
                                                url_.includes("vistabosque"))
                                                ? "row"
                                                : "column"
                                        }
                                        alignItems={
                                            url_ &&
                                            (url_.includes("aladra") ||
                                                url_.includes("deimare") ||
                                                url_.includes("vistabosque")) &&
                                            "center"
                                        }
                                    >
                                        <Box
                                            mt={{
                                                base:
                                                    url_ &&
                                                    (url_.includes("aladra") ||
                                                        url_.includes("deimare") ||
                                                        url_.includes("vistabosque"))
                                                        ? 0
                                                        : "48px",
                                                md: 8,
                                                lg: 16,
                                            }}
                                            w={
                                                url_ &&
                                                (url_.includes("aladra") ||
                                                    url_.includes("deimare") ||
                                                    url_.includes("vistabosque"))
                                                    ? "fit-content"
                                                    : "100%"
                                            }
                                            boxShadow={
                                                url_ &&
                                                (url_.includes("aladra") ||
                                                    url_.includes("deimare") ||
                                                    url_.includes("vistabosque"))
                                                    ? "none"
                                                    : "0px 4px 6px -1px rgba(0, 0, 0, 0.1)"
                                            }
                                            my={
                                                url_ &&
                                                (url_.includes("aladra") ||
                                                    url_.includes("deimare") ||
                                                    url_.includes("vistabosque")) &&
                                                "auto"
                                            }
                                            h="fit-content"
                                            mb={3}
                                            backgroundColor="#FFFFFF"
                                        >
                                            <Button
                                                backgroundColor="#FFFFFF"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setModelSelected(false);
                                                    onCloseSlide;
                                                }}
                                            >
                                                <ImageChakra
                                                    src="https://media.grupoguia.mx/vision/icon/ArrowBack.svg"
                                                    alt="arrowBack"
                                                />
                                            </Button>
                                        </Box>
                                        <Text
                                            fontWeight="bold"
                                            fontSize="xl"
                                            textAlign="center"
                                            pb={5}
                                            mt={{ base: 0, md: 16, lg: 28, "2xl": 20 }}
                                        >
                                            Unidad Seleccionada
                                        </Text>
                                    </Stack>
                                )}
                                <Box
                                    px={{ base: 5, md: 0 }}
                                    mt={{ base: 0, md: "150px" }}
                                    w={{ base: "100%", md: "35%", lg: "25%", "2xl": "30%" }}
                                    mb="40px"
                                >
                                    {multiProperty !== null && (
                                        <Select.Root
                                            collection={modelCollection}
                                            w="120px"
                                            size="sm"
                                            borderRadius="full"
                                            bg="white"
                                            value={modelSelected?.model_name}
                                            onValueChange={(detils) => {
                                                const property = multiProperty.filter(
                                                    (prop) => prop.model_name === detils.value[0]
                                                );
                                                parent.postMessage(property[0]);
                                                setModelSelected(property[0]);
                                            }}
                                            justifySelf="right"
                                            mb="10px"
                                        >
                                            <Portal>
                                                <Select.Positioner>
                                                    <Select.Content>
                                                        {modelCollection.items.map((option) => (
                                                            <Select.Item
                                                                item={option}
                                                                key={option.value}
                                                            >
                                                                {option.label}
                                                                <Select.ItemIndicator />
                                                            </Select.Item>
                                                        ))}
                                                    </Select.Content>
                                                </Select.Positioner>
                                            </Portal>
                                        </Select.Root>
                                    )}
                                    <Container
                                        borderRadius="10px"
                                        borderWidth={1}
                                        borderColor="gray.300"
                                        boxShadow="0px 5px 30px rgba(0, 0, 0, 0.6)"
                                        py="20px"
                                        px={3}
                                    >
                                        <Box
                                            bg="#002B49"
                                            p="10px"
                                            borderRadius="10px"
                                            maxW="45%"
                                            mb={2}
                                            ml={2}
                                        >
                                            <Text
                                                fontSize="sm"
                                                textAlign="center"
                                                color="white"
                                                fontWeight="bold"
                                            >
                                                Vista{" "}
                                                {modelSelected?.dimensiones.filter(
                                                    (item) => item.dimension_name === "Vista"
                                                )[0]?.item_name || viewSelected.item_name}
                                            </Text>
                                        </Box>

                                        <Center flexDirection="column">
                                            <ImageChakra
                                                w="80%"
                                                borderRadius="lg"
                                                src={
                                                    modelSelected?.render_props ||
                                                    modelSelected?.prototype_photo_props
                                                        ?.cover_image_min_url ||
                                                    modelSelected?.prototype_photo_props
                                                        ?.cover_image_url ||
                                                    modelSelected?.image
                                                }
                                                alt="simple icon"
                                            />
                                            {modelSelected?.model_koppi_props?.status ===
                                                "ACTIVE" && (
                                                <Box
                                                    w="90%"
                                                    mt={-2}
                                                    color="#000000"
                                                    bg="#FFCD00"
                                                    textAlign="center"
                                                    borderRadius="lg"
                                                    borderWidth={1}
                                                    borderColor="#000000"
                                                    p={2}
                                                    justifyItems="center"
                                                    fontSize={{ base: "sm", md: "md" }}
                                                    cursor="pointer"
                                                    _hover={{ background: "#FFCD0099" }}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setIsRouteViewer(true);
                                                    }}
                                                >
                                                    <Box display="flex" gap={3}>
                                                        <ImageChakra
                                                            src="https://media.grupoguia.mx/assets/icons/virtual_route.svg"
                                                            alt="virtual_route"
                                                            maxW="20px"
                                                        />
                                                        <Text>Ver recorrido virtual</Text>
                                                    </Box>
                                                </Box>
                                            )}
                                        </Center>
                                        <Center pt={2}>
                                            <Text
                                                textAlign="center"
                                                fontSize="20px"
                                                fontWeight={800}
                                                color="#002B49"
                                            >
                                                Modelo{" "}
                                                {modelSelected.model_name.replace(/modelo/gi, "")}
                                            </Text>
                                        </Center>
                                        <Center pt={1}>
                                            <Subtitle data={modelSelected} />
                                        </Center>
                                        <Center
                                            pt={5}
                                            mb={!modelSelected?.description ? "20px" : "0px"}
                                            mx={4}
                                        >
                                            <Amenities data={modelSelected} />
                                        </Center>
                                        {modelSelected?.description && (
                                            <Center pt={1} mb="20px" mx={4}>
                                                <Text
                                                    fontWeight={400}
                                                    fontSize="12px"
                                                    color="#000000"
                                                    textAlign="center"
                                                    whiteSpace="pre-line"
                                                >
                                                    {showDescription
                                                        ? modelSelected?.description
                                                        : `${modelSelected?.description.substring(0, 100)}...`}
                                                    <Text
                                                        fontWeight={400}
                                                        fontSize="12px"
                                                        color="blue.500"
                                                        textAlign="center"
                                                        cursor="pointer"
                                                        mt={1}
                                                        onClick={() =>
                                                            setShowDescription(!showDescription)
                                                        }
                                                    >
                                                        {showDescription
                                                            ? " Ver menos"
                                                            : " Ver más"}
                                                    </Text>
                                                </Text>
                                            </Center>
                                        )}
                                        {modelSelected?.model_features?.half_bathrooms &&
                                            modelSelected?.model_features?.half_bathrooms != "" &&
                                            modelSelected?.model_features?.half_bathrooms != "0" &&
                                            modelSelected?.model_features?.half_bathrooms > 0 && (
                                                <Flex justifyContent="center" gap="25px" mb={2}>
                                                    <Text
                                                        fontSize="sm"
                                                        fontWeight={400}
                                                        color="#949494"
                                                    >
                                                        Medios baños:
                                                        {` ${
                                                            modelSelected?.model_features
                                                                ?.half_bathrooms || 0
                                                        }`}
                                                    </Text>
                                                </Flex>
                                            )}
                                        <Flex justifyContent="center" gap="25px">
                                            <Flex>
                                                <ImageChakra
                                                    src="https://media.grupoguia.mx/assets/home-page/icons/property-card/cinta-metrica.svg"
                                                    alt="m2"
                                                    boxSize="25px"
                                                    display="inline-flex"
                                                    mr={2}
                                                />
                                                <Text
                                                    fontSize="md"
                                                    fontWeight={400}
                                                    color="#949494"
                                                >
                                                    {/* {modelSelected.model_features.max_construction_size == 0 ? modelSelected.model_features.construction_size : modelSelected.model_features.max_construction_size}m² */}
                                                    {modelSelected?.construction_size !== 0 &&
                                                    modelSelected?.construction_size
                                                        ? Number(
                                                              modelSelected.construction_size
                                                          ).toFixed(2)
                                                        : Number(
                                                              modelSelected.model_features
                                                                  .max_construction_size
                                                          ).toFixed(2)}
                                                    m²
                                                </Text>
                                            </Flex>
                                            <Flex>
                                                <ImageChakra
                                                    src="https://media.grupoguia.mx/assets/home-page/icons/property-card/cama.svg"
                                                    alt="habitaciones"
                                                    boxSize="25px"
                                                    display="inline-flex"
                                                    mr={2}
                                                />
                                                <Text
                                                    fontSize="md"
                                                    fontWeight={400}
                                                    color="#949494"
                                                >
                                                    {modelSelected.model_features.bedrooms
                                                        ? modelSelected.model_features.bedrooms
                                                        : "0"}
                                                </Text>
                                            </Flex>
                                            <Flex>
                                                <ImageChakra
                                                    src="https://media.grupoguia.mx/assets/home-page/icons/property-card/inodoro.svg"
                                                    alt="habitaciones"
                                                    boxSize="25px"
                                                    display="inline-flex"
                                                    mr={2}
                                                />
                                                <Text
                                                    fontSize="md"
                                                    fontWeight={400}
                                                    color="#949494"
                                                >
                                                    {modelSelected.model_features.bathrooms
                                                        ? modelSelected.model_features.bathrooms
                                                        : "0"}
                                                </Text>
                                            </Flex>
                                            <Flex>
                                                <ImageChakra
                                                    src="https://media.grupoguia.mx/assets/home-page/icons/property-card/carro-familiar.svg"
                                                    alt="habitaciones"
                                                    boxSize="25px"
                                                    display="inline-flex"
                                                    mr={2}
                                                />
                                                <Text
                                                    fontSize="md"
                                                    fontWeight={400}
                                                    color="#949494"
                                                >
                                                    {modelSelected.model_features.parking_lots
                                                        ? modelSelected.model_features.parking_lots
                                                        : "0"}
                                                </Text>
                                            </Flex>
                                        </Flex>
                                    </Container>
                                    <Center>
                                        {url_ &&
                                            modelSelected &&
                                            url_.includes("catalogs/clients/following") && (
                                                <Stack mt={2}>
                                                    <Button
                                                        bg="brand.500"
                                                        color="black"
                                                        border="1px"
                                                        borderColor="#B8B8B8"
                                                        rounded="full"
                                                        w="auto"
                                                        fontWeight="500"
                                                        fontSize="sm"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            handleChangeUnity();
                                                        }}
                                                        pt="20px"
                                                    >
                                                        Cambiar por esta unidad
                                                    </Button>
                                                </Stack>
                                            )}
                                    </Center>
                                </Box>
                            </>
                        ) : (
                            window.innerWidth > 480 && (
                                <Box
                                    w={{ base: "100%", md: "35%", lg: "50%", "2xl": "45%" }}
                                    display="flex"
                                    justifyContent="center"
                                    flexDirection="column"
                                    mt={{ sm: 240, md: 16, "2xl": 20 }}
                                    mb="40px"
                                >
                                    <Container>
                                        <Center display="flex" flexDirection="column" gap="12px">
                                            <Text fontSize="14px" fontWeight="400">
                                                Selecciona un departamento
                                            </Text>
                                            <ImageChakra
                                                src="https://media.grupoguia.mx/assets/icons/Icon_seleccion_2d.png"
                                                alt="simple icon"
                                            />
                                        </Center>
                                    </Container>
                                </Box>
                            )
                        )}

                        {!modelSelected && window.innerWidth <= 480 ? (
                            <>
                                <Box
                                    mt={{
                                        base:
                                            url_ &&
                                            (url_.includes("aladra") ||
                                                url_.includes("deimare") ||
                                                url_.includes("vistabosque"))
                                                ? 0
                                                : 90,
                                        md: 8,
                                        lg: 16,
                                    }}
                                    w="100%"
                                    h="fit-content"
                                    mb={3}
                                    backgroundColor="#FFFFFF"
                                    boxShadow="0px 4px 6px -1px rgba(0, 0, 0, 0.1)"
                                >
                                    {/* {url_ && !(url_.includes('aladra') || url_.includes('deimare') || url_.includes('vistabosque')) && (
                                    <Button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            router.back();
                                            }}
                                        backgroundColor={'#FFFFFF'}
                                    >
                                        <ImageChakra src='https://media.grupoguia.mx/vision/icon/ArrowBack.svg' alt='arrowBack'/>
                                    </Button>
                                )} */}
                                </Box>
                                <Container
                                    ml={{ base: "0", md: "5em", lg: "2em", xl: "5em" }}
                                    w={{ md: "100%", lg: "35%" }}
                                    h="220px"
                                >
                                    <Text
                                        fontSize="20px"
                                        fontWeight="700"
                                        textAlign={{ base: "center", md: "left" }}
                                    >
                                        ¡Elige la unidad para ti!
                                    </Text>
                                    <Text px={{ base: 5, md: 2 }} pt={4} fontSize="14px">
                                        1. Selecciona la vista que deseas en el recuadro superior
                                        derecho de la imagen.
                                    </Text>
                                    <Text px={{ base: 5, md: 2 }} pt={4} fontSize="14px">
                                        2. Da clic sobre el nivel y la unidad de tu interés para
                                        conocer todos los detalles.
                                    </Text>
                                    <HStack pt={7} gap="12px" mx={2}>
                                        <Box
                                            h="20px"
                                            w="50px"
                                            bg="#B3C86C"
                                            borderRadius="6px"
                                        ></Box>
                                        <Text fontSize="12px">Disponible</Text>
                                        <Box
                                            h="20px"
                                            w="50px"
                                            bg="#EF3E3F"
                                            borderRadius="6px"
                                        ></Box>
                                        <Text fontSize="12px">Vendido o en proceso</Text>
                                        <Box
                                            h="20px"
                                            w="50px"
                                            bg="#FFCD00"
                                            borderRadius="6px"
                                        ></Box>
                                        <Text fontSize="12px">Apartado</Text>
                                    </HStack>
                                </Container>
                                <Box
                                    mt={
                                        modelSelected
                                            ? { base: 5, sm: 10, lg: "15%" }
                                            : { base: 0, sm: 24, lg: "15%" }
                                    }
                                    w={{ base: "100%", lg: "50%", "2xl": "55%" }}
                                    position="relative"
                                    top={innerWidth >= 750 ? "-120px" : 0}
                                >
                                    <Stack maxW="90%" alignItems="end">
                                        {renders && !isOneRender && (
                                            <Select.Root
                                                collection={viewCollection}
                                                w="120px"
                                                size="sm"
                                                borderRadius="full"
                                                bg="white"
                                                value={
                                                    viewName ? [viewName] : [viewOptions[0]?.value]
                                                }
                                                onValueChange={(details) => {
                                                    selectedView(details.value[0]);
                                                }}
                                            >
                                                <Select.HiddenSelect />
                                                <Select.Control>
                                                    <Select.Trigger pl={4} rounded="full">
                                                        <Select.ValueText
                                                            placeholder="Selecciona una vista"
                                                            overflowWrap="break-word"
                                                            whiteSpace="normal"
                                                            color="gray.600"
                                                        />
                                                    </Select.Trigger>
                                                    <Select.IndicatorGroup pr={4}>
                                                        <Select.Indicator />
                                                    </Select.IndicatorGroup>
                                                </Select.Control>
                                                <Portal>
                                                    <Select.Positioner>
                                                        <Select.Content p={2}>
                                                            {viewCollection.items.map((option) =>
                                                                option && option !== "undefined" ? (
                                                                    <Select.Item
                                                                        item={option}
                                                                        key={option.value}
                                                                        color="gray.600"
                                                                        p={1}
                                                                    >
                                                                        {option.label}
                                                                        <Select.ItemIndicator />
                                                                    </Select.Item>
                                                                ) : null
                                                            )}
                                                        </Select.Content>
                                                    </Select.Positioner>
                                                </Portal>
                                            </Select.Root>
                                        )}
                                    </Stack>

                                    <Box
                                        position="relative"
                                        width="100%"
                                        /*  mb={'70px'} */ mt="30px"
                                        mr={{ base: "0", md: "20px" }}
                                    >
                                        <SVG
                                            style={{
                                                width: "100%",
                                                height: "auto",
                                                maxHeight: limitImage ? "500px" : "5000px",
                                            }}
                                            id="svg"
                                            src={viewSelected?.map_image_url}
                                            onClick={(e) => handleClick(e)}
                                            onLoad={loadSvg}
                                        />
                                    </Box>
                                </Box>
                            </>
                        ) : (
                            window.innerWidth > 480 && (
                                <>
                                    <Box
                                        mt={{ base: 0, sm: 24, lg: "15%" }}
                                        w={{ base: "100%", md: "65%", lg: "50%", "2xl": "55%" }}
                                        position="relative"
                                        top={{ base: 0, lg: "-120px" }}
                                    >
                                        <Stack maxW="90%" alignItems="end">
                                            {renders && !isOneRender && (
                                                <Select.Root
                                                    collection={viewCollection}
                                                    w="120px"
                                                    size="sm"
                                                    borderRadius="full"
                                                    bg="white"
                                                    value={
                                                        viewName
                                                            ? [viewName]
                                                            : [viewOptions[0]?.value]
                                                    }
                                                    onValueChange={(details) => {
                                                        selectedView(details.value[0]);
                                                    }}
                                                >
                                                    <Select.HiddenSelect />
                                                    <Select.Control>
                                                        <Select.Trigger pl={4} rounded="full">
                                                            <Select.ValueText
                                                                placeholder="Selecciona una vista"
                                                                overflowWrap="break-word"
                                                                whiteSpace="normal"
                                                                color="gray.600"
                                                            />
                                                        </Select.Trigger>
                                                        <Select.IndicatorGroup pr={4}>
                                                            <Select.Indicator />
                                                        </Select.IndicatorGroup>
                                                    </Select.Control>
                                                    <Portal>
                                                        <Select.Positioner>
                                                            <Select.Content p={2}>
                                                                {viewCollection.items.map(
                                                                    (option) => {
                                                                        return (
                                                                            !!option && (
                                                                                <Select.Item
                                                                                    item={option}
                                                                                    key={
                                                                                        option.value
                                                                                    }
                                                                                    color="gray.600"
                                                                                    p={1}
                                                                                >
                                                                                    {option.label}
                                                                                    <Select.ItemIndicator />
                                                                                </Select.Item>
                                                                            )
                                                                        );
                                                                    }
                                                                )}
                                                            </Select.Content>
                                                        </Select.Positioner>
                                                    </Portal>
                                                </Select.Root>
                                            )}
                                        </Stack>

                                        <Box
                                            position="relative"
                                            width="100%"
                                            /*  mb={'70px'} */ mt="30px"
                                            mr={{ base: "0", md: "20px" }}
                                        >
                                            <SVG
                                                style={{
                                                    width: "100%",
                                                    height: "auto",
                                                    maxHeight: limitImage ? "600px" : "5000px",
                                                }}
                                                id="svg"
                                                src={viewSelected?.map_image_url}
                                                onClick={(e) => handleClick(e)}
                                                onLoad={loadSvg}
                                            />
                                        </Box>
                                    </Box>
                                </>
                            )
                        )}
                    </Box>
                    {url_ && modelSelected && url_.includes("inventory/development") && (
                        <Box
                            position="fixed"
                            bottom="0"
                            left="0"
                            width="100%"
                            zIndex={10}
                            transform={isSlideOpenVision ? "translateY(0)" : "translateY(100%)"}
                            opacity={isSlideOpenVision ? 1 : 0}
                            transition="all 0.3s ease-out"
                            pointerEvents={isSlideOpenVision ? "auto" : "none"}
                        >
                            <Box
                                p={{ base: "15px", md: "25px" }}
                                bg="#FFFFFF"
                                rounded="md"
                                backgroundColor="transparent"
                            >
                                <Box
                                    display={{ base: "block", lg: "flex" }}
                                    justifyContent="center"
                                    justifySelf="center"
                                >
                                    <Button
                                        bg="brand.500"
                                        color="black"
                                        borderRadius="10px"
                                        borderColor="#B8B8B8"
                                        w={{ base: "250px", md: "300px" }}
                                        fontWeight="500"
                                        fontSize={{ base: "sm", md: "md" }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleHook();
                                        }}
                                    >
                                        Cotizar / ver esquemas de pago
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    )}
                    {url_ &&
                        modelSelected &&
                        url_ &&
                        (url_.includes("aladra") ||
                            url_.includes("deimare") ||
                            url_.includes("vistabosque")) && (
                            <Stack pb="15px" display="flex" justifyContent="center" direction="row">
                                <Button
                                    bg="brand.500"
                                    color="black"
                                    borderRadius="10px"
                                    borderColor="#B8B8B8"
                                    w="auto"
                                    fontWeight="500"
                                    fontSize="md"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleHook();
                                    }}
                                >
                                    Cotizar / ver esquemas de pago
                                </Button>
                            </Stack>
                            //</Slide>
                        )}
                    {/* <ModalTutorial /> */} {/* UNNUSED COMPONENT */}
                </Stack>
            )}
        </>
    );
};

const Amenities = ({ data }) => {
    const [verMas, setVerMas] = useState(false);

    let equipment = [];
    // ===== FORMAT OF STRING =====
    data.model_equipment.forEach((element, idx) => {
        let text = element.charAt(0).toUpperCase() + element.slice(1);
        text = text.replace(/-/g, " ");
        text = " • " + text;
        equipment[idx] = text;
    });

    if (data.model_equipment.length > 6) {
        return (
            <Center pt={1} display="flex" flexDirection="column" gap={0}>
                <Text color="black" fontWeight={400} fontSize="2xs" mt={4} textAlign="center">
                    {data?.model_equipment.slice(0, 6)?.map((item, index) => (
                        <span key={index} style={{ display: "inline" }}>
                            {" "}
                            • {item}{" "}
                        </span>
                    ))}
                </Text>
                <Box
                    filter={!verMas ? "blur(2px)" : ""}
                    height="auto"
                    transition="filter 0.3s ease"
                >
                    <Text color="black" fontWeight={400} fontSize="2xs" textAlign="center" mb={0}>
                        <span style={{ display: "inline" }}>
                            •{" "}
                            {data?.model_equipment
                                .slice(6, !verMas ? 7 : data?.model_equipment.length)
                                .join(" • ")}
                        </span>
                    </Text>
                </Box>
                <Button
                    position="top"
                    background="transparent"
                    padding={0}
                    color="black"
                    _hover={{ background: "transparent" }}
                    display={verMas ? "none" : "block"}
                    onClick={(e) => {
                        e.preventDefault();
                        setVerMas(true);
                    }}
                    fontSize="sm"
                >
                    Ver Más ...
                </Button>
            </Center>
        );
    } else {
        return (
            <Box w="90%" pb={window.innerWidth > 1000 ? "20px" : "0px"}>
                <Text textAlign="center" fontSize="12px" fontWeight="400">
                    {equipment}
                </Text>
            </Box>
        );
    }
};

const Subtitle = ({ data }) => {
    let piso = "";
    data.dimensiones.forEach((element) => {
        if (element.dimension_name === "Piso") {
            piso = element.item_name;
        }
    });

    const text =
        "Departamento " + data?.external_props?.wiggot?.apartment_number + " • Nivel " + piso;

    return (
        <Box>
            <Text fontSize="19px" fontWeight={500} color="#002B49">
                {text}
            </Text>
        </Box>
    );
};

export default Seleccion2D;
